// @flow
import React from 'react';
import Select from 'react-select';
import Globe from '../../ressources/images/icons/globe.png';
import './index.less';

const LanguagePanel = (props) => {

   const { language, right } = props;
   const options = [
      { value: 'EN', label: "EN" },
      { value: 'FR', label: "FR" },
      { value: 'LU', label: "LU" },
      { value: 'DE', label: "DE" },
      { value: 'PT', label: "PT" },
      { value: 'NL', label: "NL" }
   ].filter(name => name.label !== language.toUpperCase());

   const desktopStyle = {
      control: (provided) => ({
         ...provided,
         boxShadow: "none",
         border: "none",
         cursor: 'pointer'
      }),
      menu: (provided) => ({
         ...provided,
         border: "none",
      }),
      option: (provided, { isFocused }) => ({
         ...provided,
         cursor: 'pointer',
         backgroundColor: isFocused ? "rgba(117, 47, 168, 0.3);" : null,
         "&:hover": {
            background: "rgba(117, 47, 168, 0.3);"
         },
         textAlign: 'center'
      })
   }

   const mobileStyle = {
      control: (provided, state) => ({
         ...provided,
         boxShadow: "none",
         borderRadius: 'none',
         borderColor: 'black',
         borderLeft: "none",
         borderRight: "none",
         "&:hover": {
            borderColor: "black"
         },
         cursor: 'pointer'
      }),
      menu: (provided, state) => ({
         ...provided,
         border: "none",
         borderRadius: 'none',
         boxShadow: "none"
      }),
      option: (provided, { isFocused }) => ({
         ...provided,
         borderStyle: 'solid',
         borderWidth: '1px',
         borderLeft: "none",
         borderRight: "none",
         borderTop: "none",
         borderColor: "black",
         width: "100%",
         height: "40px",
         textAlign: "center",
         cursor: 'pointer',
         backgroundColor: isFocused ? "rgba(117, 47, 168, 0.3);" : null,
         "&:hover": {
            background: "rgba(117, 47, 168, 0.3);"
         }
      })
   }

   return (
      <div
         className={props.isRunningOnMobile ? null : "language-panel-selection-desktop-container"}
         style={{ margin: right ? '-24px 2% 0 auto' : '-24px 2% auto' }}
      >
         <Select
            isSearchable={false}
            styles={props.isRunningOnMobile ? mobileStyle : desktopStyle}
            value={"default"}
            className={props.isRunningOnMobile ? null : "language-panel-selection-desktop-container__dropdown"}
            placeholder={
               <div className={'language-panel-selection-placeholder'}>
                  <div>
                     <img className={'language-panel-selection-placeholder__image'} src={Globe} alt={'Globe language'} height="18px" width="18px" />
                  </div>
                  <div>
                     <span className={'language-panel-selection-placeholder__text'}> {language.toUpperCase()}</span>
                  </div>
               </div>
            }
            onChange={props.onLanguageChange}
            options={options}
         />
      </div>
   )
}

export default (LanguagePanel);
